import { useEffect, useState } from 'react';

/** Matches Tailwind `screens.nav-primary-inline` in tailwind.config.js (inline nav / header chrome). */
export const NAV_PRIMARY_INLINE_MIN_PX = 1025;

/** Matches Tailwind default `lg` screen (AppearancePopover stays in header from tablet width up). */
export const LG_MIN_PX = 1024;

function useMatchMinWidth(minPx: number): boolean {
  const query = `(min-width: ${minPx}px)`;
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : true
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    setMatches(mq.matches);
    const onChange = () => setMatches(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/**
 * True when viewport width is at least {@link NAV_PRIMARY_INLINE_MIN_PX}px.
 */
export function useNavPrimaryInlineOrWider(): boolean {
  return useMatchMinWidth(NAV_PRIMARY_INLINE_MIN_PX);
}

/**
 * True when viewport width is at least {@link LG_MIN_PX}px (Tailwind `lg` — tablet/desktop).
 * Used so AppearancePopover stays in the header at 1024px while primary nav may still use the hamburger.
 */
export function useLgOrWider(): boolean {
  return useMatchMinWidth(LG_MIN_PX);
}
